import { DestroyRef, Injectable, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingMessageModalComponent } from './loading-message-modal.component';

@Injectable({
  providedIn: 'root',
})
export class LoadingMessageModalService implements OnDestroy {
  constructor(private modalService: NgbModal, private destroyRef: DestroyRef) {}

  private modalRef: NgbModalRef | null = null;

  openModal(message: string): NgbModalRef {
    // Close any existing modal before opening a new one
    this.closeModal();

    this.modalRef = this.modalService.open(LoadingMessageModalComponent, {
      size: 'sm',
      ariaLabelledBy: 'loading-message-modal',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    this.modalRef.componentInstance.message = message;

    return this.modalRef;
  }

  closeModal() {
    this.modalRef?.close();
    this.modalRef = null;
  }

  ngOnDestroy() {
    this.closeModal();
  }
}
